<div class="block-title" [innerHTML]="block.blockTitle"></div>

<div class="swiper--slides-block">
  <div class="swiper" #swiper>
    <div class="swiper-wrapper">
      <div *ngFor="let slide of block.slides; index as i" class="swiper-slide">
        <img src="{{slide.imageUrl}}" class="align-center" alt="{{slide.name}}" />
      </div>
    </div>
  </div>
</div>